import React, { useEffect, useRef, useState } from 'react';

import Layout from '../../wrappers/layout';

import PageHeader from '../../shared/page-header';
import { Card, Tab, Tabs, Button, Form, InputGroup } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
// import { Form } from 'formik';
import './styles.css';
import RadioCard from 'pages/signup/components/radioCard';
// import  './faq.css';
// var perf =require('./faq.html');
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { userStore } from 'store/UserStore';
import { formatAmount, makeQuery } from '../../utils';
import SipHttp from './sip.service';
import * as Yup from 'yup';
import SipSummary from './SipSummary';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import { ToastContainer, toast } from 'react-toastify';
// import Datetime from 'react-datetime';

interface PropsType {}

const SipSavingPlan: React.FC<PropsType> = () => {
  const location = useLocation();
  const data = location.state;
  const today = new Date();
  const todayDate = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
  const fivedaysAhead = moment(today.setDate(today.getDate() + 5)).format(
    'YYYY-MM-DD'
  );

  const [expand, setExpand] = useState(0);
  const [sipPlanName, setSipPlanName] = useState('');
  const [investInterval, setInvestInterval] = useState(data.sipInterval);
  const [metalType, setMetalType] = useState(data.sipMetalType);
  const [sipAmount, setSipAmount] = useState(data.sipAmount);
  const [sipGram, setSipGram] = useState(data.sipGram);
  const [sipType, setSipType] = useState('');
  const [emandates, setEmandates] = useState('withMandateUPI');
  const [sipMethod, setSipMethod] = useState('payemandate');
  const [termCondition, setTermCondition] = useState();
  const [startDate, setStartDate] = useState<any | null>(fivedaysAhead);
  // const [manualstartDate, setmanualStartDate] = useState<any | null>(todayDate);
  const [emandateList, setEmandateList] = useState([]);
  const [dislaySipSummary, setDislaySipSummary] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [isConsented, setIsConsented] = useState(false);
  const [investAmtField, setInvestAmtField] = useState(false);
  const [investGramField, setInvestGramField] = useState(false);
  const [customerId, setUser, user, selectedAccount] = userStore(
    (state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.selectedAccount,
    ]
  );
  const [newSIP, setNewSIP] = useState({
    plan_name: '',
    frequency: data.sipInterval,
    installment_amt: data.sipAmount,
    grams: data.sipGram,
    metal: data.sipMetalType,
    duration: '3',
    start_date: startDate,
    bank: '',
    customer_id: customerId,
    is_payment_manual: false,
    isupi: false,
  });

  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });
  const dateForPicker = (dateString) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD');
  };

  const dateFromDateString = (dateString) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD');
  };

  // const dateForPicker = (date) => {
  //   return date ? format(date, 'yyyy-MM-dd') : '';
  // };

  // const dateFromDateString = (dateString) => {
  //   return dateString ? parse(dateString, 'yyyy-MM-dd', new Date()) : null;
  // };
  const getEmandateList = async () => {
    try {
      const query = makeQuery({
        customerId: customerId,
        status: 'CONFIRMED',
        user_id: user?.userId,
      });
      SipHttp.getEmandatesList(query, customerId)
        .then((res: any) => {
          if (res && res.data.data[0]) {
            const objectAsArray: any = Object.values(res?.data?.data[0]);
            setEmandateList(res?.data?.data);
            setEmandates('withoutMandate');
            setNewSIP({
              ...newSIP,
              bank: res?.data?.data[0]?.bank,
            });
            //@ts-ignore
            validation.bank = Yup.string().required('Please enter bank.');
          }
        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const validation = Yup.object().shape({
    // installment_amt: Yup.string().nullable().required('Please enter amount or gram'),
    // grams: Yup.string().nullable().required('Please enter gram'),
    // plan_name: Yup.string().required('Please enter plan name.'),
    plan_name: Yup.string()
      .matches(
        /^[A-Za-z0-9\s]+$/,
        'Plan name must only contain letters and numbers'
      )
      .required('Please enter plan name.'),

    bank: Yup.string(),
    // duration: Yup.string().required('Please enter frequency'),
    // start_date: Yup.string().required('valid date'),
  });

  useEffect(() => {
    getEmandateList();
    if (data?.sipAmount) {
      setInvestGramField(true);
    } else {
      setInvestAmtField(true);
    }
  }, []);

  const dateForState = (date) => {
    return date ? date.split('-').reverse().join('-') : '';
  };

  const validateGramsforMetal = () => {
    console.log('metalType', metalType);
    let gramErr = true;
    switch (metalType) {
      case 'Ag':
        if (metalType == 'Ag' && (newSIP?.grams < 2 || newSIP?.grams > 1000)) {
          toast.error('Silver should be between 2g to 1kg');
          return gramErr;
          break;
        }
      case 'Pt':
        if (metalType == 'Pt' && (newSIP?.grams < 1 || newSIP?.grams > 20)) {
          toast.error('Platinum should be between 1g to 20g');
          return gramErr;

          break;
        }

      case 'Pd':
        if (metalType == 'Pd' && (newSIP?.grams < 1 || newSIP?.grams > 15)) {
          toast.error('Palladium should be between 1g to 15g');
          return gramErr;

          break;
        }
      case 'Au':
        if (metalType == 'Au' && (newSIP?.grams < 1 || newSIP?.grams > 10)) {
          toast.error('Gold should be between 1g to 10g');
          return gramErr;

          break;
        }
      default:
        return false;
    }
  };

  const createSIP = async (values) => {
    if (emandates == 'withoutMandate' && newSIP?.bank == '') {
      return toast.error('Select Bank');
    } else if (newSIP?.installment_amt == null && newSIP?.grams == null) {
      return toast.error('Please enter investment amount ');
    } else if (
      newSIP?.installment_amt < 100 ||
      newSIP?.installment_amt > 100000
    ) {
      return toast.error('Amount should be between ₹100 to ₹100000 ');
    } else if (
      sipMethod == 'payemandate' &&
      newSIP?.start_date < fivedaysAhead
    ) {
      return toast.error(
        `Start date should be greater than or equal to ${moment(
          fivedaysAhead
        ).format('DD-MM-YYYY')}`
      );
    } else if (sipMethod == 'paymanual' && newSIP?.start_date < todayDate) {
      console.log('here', newSIP?.start_date);

      return toast.error(
        `Start date should be greater than or equal to ${moment(
          todayDate
        ).format('DD-MM-YYYY')}`
      );
    }
    setDislaySipSummary(true);
  };

  const onHandleSideModal = (value) => {
    setDislaySipSummary(false);
  };

  /**
   * Set initial state to razorpay data
   */
  // const setInitialStateRazorpay = () => {
  //   setRazorpay({
  //     customerId: customerId,
  //     amount: null,
  //     transactionTypeId: 'eb-o-00333',
  //     paymentMethod: 'NEBK',
  //   });
  // };

  // const checkPaymentStatus = async (paymentId, orderId) => {
  //   try {
  //     let payload = {
  //       paymentId,
  //       orderId,
  //     };
  //     setLoading(true);
  //     const res = await BuySellService.checkPaymentStatus(
  //       payload,
  //       abortControllerRef.current.signal
  //     );
  //   } catch (error) {
  //   } finally {
  //     setLoading(false);
  //     let newData = await getOrderDetails(orderId);
  //     return await handleOrderSummaryModal(newData);
  //   }
  // };

  // const setPaymentGatewayConfiguration = async (data) => {
  //   setLoading(false);
  //   const options: RazorpayOptions = {
  //     key: process.env.REACT_APP_RAZORPAY_KEY,
  //     amount: '',
  //     currency: 'INR',
  //     name: 'eBullion',
  //     description: 'Buy Metals',
  //     image:
  //       'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
  //     order_id: '',
  //     async handler(response: any) {
  //       setLoading(true);
  //       const payload = {
  //         customerId: razorpay.customerId,
  //         razorpayOrderId: response.razorpay_order_id,
  //         razorpayPaymentId: response.razorpay_payment_id,
  //         razorpaySignature: response.razorpay_signature,
  //         razorpayRequestBody: {
  //           amount: razorpay.amount,
  //           currency: 'INR',
  //           // test: 'testUPIwithRPY',
  //         },
  //       };

  //       // const res: any =
  //       //   paymentMethod === 'UPI'
  //       //     ? await BuySellService.verifyUPIPaymentRazorpay(payload)
  //       //     : await BuySellService.verifyNEBKPaymentRazorpay(payload);
  //       // if (res.status === 200 && res.data.data) {
  //       setInitialStateRazorpay();
  //       await checkPaymentStatus(
  //         response.razorpay_payment_id,
  //         data?.ebOrderRef
  //       );
  //       // }
  //     },
  //     prefill: {
  //       name: user.displayName,
  //       email: user.email.value,
  //       contact: user.mobile.value,
  //       method: paymentMethod === 'UPI' ? 'upi' : 'netbanking',
  //     },
  //     notes: {
  //       address: selectedAccount.billingAddress.address1,
  //     },
  //     theme: {
  //       hide_topbar: false,
  //       color: '#141034',
  //       backdrop_color: 'rgba(0, 0, 0, 0.90)',
  //     },
  //     timeout: 180,
  //   };

  //   // if (data.meta.payment.response.data.meta.length > 0) {
  //   //   options.order_id = data?.meta?.payment?.response.data.meta.filter(
  //   //     (data: any) => data.key === 'RPY_ORDER_ID'
  //   //   )[0].value;
  //   // }
  //   // razorpay.amount = data.meta.payment.response.data.amount;
  //   // options.amount = (razorpay.amount * 100).toString();
  //   // const razorPay = new Razorpay(options);
  //   // return razorPay.open();

  //   if (paymentMethod === 'UPI') {
  //     if (
  //       data.meta.payment.response.data.meta.length > 0 &&
  //       data?.meta?.payment?.response.data.meta.filter(
  //         (data: any) => data.key === 'PAYMENT_PROVIDER'
  //       )[0].value === 'RPY'
  //     ) {
  //       options.order_id = data?.meta?.payment?.response.data.meta.filter(
  //         (data: any) => data.key === 'RPY_ORDER_ID'
  //       )[0].value;
  //       razorpay.amount = data.meta.payment.response.data.amount;
  //       options.amount = (razorpay.amount * 100).toString();
  //       const razorPay = new Razorpay(options);
  //       return razorPay.open();
  //     } else {
  //       setInitialStateRazorpay();
  //       setLoading(false);
  //       await handleOrderSummaryModal(data);
  //     }
  //   }

  //   if (paymentMethod === 'NEBK') {
  //     if (data.meta.payment.response.data.meta.length > 0) {
  //       options.order_id = data?.meta?.payment?.response.data.meta.filter(
  //         (data: any) => data.key === 'RPY_ORDER_ID'
  //       )[0].value;
  //     }
  //     razorpay.amount = data.meta.payment.response.data.amount;
  //     options.amount = (razorpay.amount * 100).toString();
  //     const razorPay = new Razorpay(options);
  //     return razorPay.open();

  //     // const res: any = await BuySellService.buyWithNEBK(razorpay);
  //     // if (res.status === 200 && res.data.data.notes.length > 0) {
  //     //   setLoading(false);
  //     //   options.amount = (razorpay.amount * 100).toString();
  //     //   options.order_id = res.data.data.notes[0].rpyOrderId;
  //     //   const razorPay = new Razorpay(options);
  //     //   return razorPay.open();
  //     // }
  //   }
  // };
  // console.log('startDate', startDate);
  return (
    <Layout>
      <div style={{ backgroundColor: 'white' }}>
        {/* <PageHeader
          mainTitle={'user.displayName'}
          subTitle=''
        /> */}
        {/* <div className='saving-main-div'>
          <h4>Create new SIP</h4> */}
        <Formik
          initialValues={{
            plan_name: '',
            frequency: data.sipInterval,
            installment_amt: data?.installment_amt,
            grams: data?.sipGram,
            metal: data.sipMetalType,
            duration: '',
            bank: '',
          }}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            setSubmitting(false);
            // save(values, setErrors);

            createSIP(values);
          }}
          validationSchema={validation}
        >
          {({
            values,
            isSubmitting,
            errors,
            touched,
            setErrors,
            setFieldValue,
            setFieldTouched,
            isValid,
            dirty,
          }) => (
            <FormikForm>
              <div className='saving-main-div'>
                <h4>Create new SIP</h4>
                <Card className='plan-card-com '>
                  {/* <pre>{JSON.stringify(values)}</pre>
                  <pre>{JSON.stringify(errors)}</pre>
                  <pre>{JSON.stringify(touched)}</pre> */}
                  <Card.Body>
                    <div className='saving-plan-container p-2'>
                      <div>
                        <Form.Group className='mb-3' controlId='orderType'>
                          <Form.Label>SIP plan name</Form.Label>
                          {/* <Form.Select
                      aria-label='Default select example'
                      name='qType'
                      // onChange={(e) => handleChangeFilter(e)}
                      value={'filter.qType'}
                    >
                      <option value='Gold'>Gold</option>
                      <option value='Silver'>Silver</option>
                      <option value='Platinum'>Platinum</option>
                      <option value='Palladium'>Palladium</option>
                    </Form.Select> */}
                          {/* <Form.Control
                          type='text'
                          value={sipPlanName}
                          onChange={(e) => setSipPlanName(e.target.value)}
                        /> */}
                          <Field
                            type='text'
                            placeholder=''
                            name='plan_name'
                            className='form-control'
                            onBlur={(e) => {
                              setFieldTouched('plan_name');
                            }}
                            onChange={(e: any) => {
                              setFieldValue('plan_name', e.target.value);
                              setNewSIP({
                                ...newSIP,
                                plan_name: e.target.value,
                              });
                              //   changeAddress(e);
                            }}
                            defaultValue={newSIP?.plan_name}
                          />
                          <div className='error text-danger ml-2'>
                            {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                            <ErrorMessage name='plan_name'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>

                          <Form.Label className='sip-margin'>
                            Precious Metal Type
                          </Form.Label>
                          <div className='radio-div sip-plan-radio-div'>
                            <Form.Check
                              type='radio'
                              label='Silver'
                              checked={metalType == 'Ag' ? true : false}
                              name='metal'
                              value={'Ag'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                              className='custom-radio-button'
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Au' ? true : false}
                              label='Gold'
                              name='metal'
                              value={'Au'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Pt' ? true : false}
                              label='Platinum'
                              name='metal'
                              value={'Pt'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Pd' ? true : false}
                              label='Palladium'
                              name='metal'
                              value={'Pd'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                            />
                          </div>

                          <Form.Label className='sip-margin'>
                            Frequency
                          </Form.Label>
                          <div className='radio-div sip-plan-radio-div'>
                            <Form.Check
                              type='radio'
                              label='Weekly'
                              checked={
                                investInterval == 'weekly' ? true : false
                              }
                              name='payment-group'
                              value={'weekly'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  frequency: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={
                                investInterval == 'monthly' ? true : false
                              }
                              label='Monthly'
                              name='payment-group'
                              value={'monthly'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  frequency: e.target.value,
                                });
                              }}
                            />
                          </div>

                          <Form.Label className='sip-margin'>
                            Investment Amount
                          </Form.Label>
                          <CurrencyInput
                            // disabled={
                            //   customer.active === 'DISABLED' ||
                            //   Object.keys(selectedAccount).length === 0 ||
                            //   selectedAccount.active === 'DISABLED'
                            // }
                            disabled={investAmtField}
                            className=' form-control'
                            name='installment_amt'
                            allowNegativeValue={false}
                            // value={razorpay.amount}
                            onWheel={(e: any) => e.target.blur()}
                            // onValueChange={
                            //   (value, name) => {
                            //     Number(value) > 0
                            //       ? setNewSIP({
                            //           ...newSIP,
                            //           installment_amt: Number(value),
                            //         })
                            //       : setNewSIP({
                            //           ...newSIP,
                            //           installment_amt: Number(null),
                            //         });
                            //   }

                            // }
                            onValueChange={
                              (value, name) => {
                                if (value !== null && Number(value) > 0) {
                                  setSipAmount(value);
                                  setNewSIP({
                                    ...newSIP,
                                    installment_amt: Number(value),
                                  });
                                } else {
                                  setSipAmount(null);
                                  setNewSIP({
                                    ...newSIP,
                                    installment_amt: Number(null),
                                  });
                                }
                              }

                              // onChangeAmount(value, name, true)
                            }
                            value={newSIP?.installment_amt}
                            // prefix='₹ '
                            placeholder='₹ 0'
                            onChange={(e: any) => {
                              setFieldValue('installment_amt', e.target.value);
                              if (e.target.value == '') {
                                console.log('oo', e.target.value);
                                setInvestGramField(false);
                              } else {
                                console.log('ooo', e.target.value);

                                setInvestGramField(true);
                              }
                            }}
                            maxLength={6}
                            decimalsLimit={2}
                          />
                          <div className='error text-danger ml-2'>
                            <ErrorMessage name='installment_amt'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>
                          {/* <hr /> */}

                          {/* ------- Grams Input ------ */}
                          {/* <Form.Label className='sip-margin'>
                            Investment Quantity
                          </Form.Label>
                          <CurrencyInput
                            disabled={investGramField}
                            className='text-start form-control'
                            name='grams'
                            allowNegativeValue={false}
                            value={newSIP?.grams}
                            onWheel={(e: any) => e.target.blur()}
                            onValueChange={(value, name) => {
                              if (value !== null && Number(value) > 0) {
                                setSipGram(value);
                                setNewSIP({
                                  ...newSIP,
                                  grams: value,
                                });
                              } else {
                                setSipGram(null);
                                setNewSIP({
                                  ...newSIP,
                                  grams: null,
                                });
                              }
                            }}
                            onBlur={(e) => {
                              setFieldTouched('grams');
                            }}
                            onChange={(e: any) => {
                              setFieldValue('grams', e.target.value);

                              if (e.target.value == '') {
                                setInvestAmtField(false);
                              } else {
                                setInvestAmtField(true);
                              }
                            }}
                            // prefix={newSIP.installment_amt == '' ? '' : '₹ '}
                            decimalsLimit={4}
                            maxLength={7}
                            placeholder='0.0000 g'
                          />

                          <div className='error text-danger ml-2'>
                            <ErrorMessage name='grams'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div> */}

                          {/* <Datetime
                            timeFormat={''}
                            dateFormat={'DD/MM/YYYY'}
                            inputProps={{
                              placeholder: 'pick date',
                              className: 'focus:outline-none',
                            }}
                            className={`rounded-md shadow-sm appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-2 px-4`}
                            onChange={(event: any) =>
                              setNewSIP({
                                ...newSIP,
                                start_date: moment(
                                  new Date(event).toISOString()
                                ).format('MM/DD/YYYY'),
                              })
                            }
                            value={moment(newSIP.start_date)}
                            renderInput={(props) => {
                              return (
                                <input
                                  style={{ width: '100%' }}
                                  {...props}
                                  value={
                                    newSIP.start_date ? newSIP.start_date : ''
                                  }
                                />
                              );
                            }}
                          /> */}

                          <Form.Label className='sip-margin'>
                            SIP Duration
                          </Form.Label>
                          <Form.Select
                            aria-label='Default select example'
                            name='duration'
                            onChange={(e) => {
                              setSipType(e.target.value);
                              setNewSIP({
                                ...newSIP,
                                duration: e.target.value,
                              });
                            }}
                            value={newSIP?.duration}
                          >
                            <option value='3'>3 months</option>
                            <option value='6'>6 months</option>
                            <option value='9'>9 months</option>
                            <option value='12'>12 months</option>
                            <option value='24'>24 months</option>
                          </Form.Select>

                          <Form.Label className='sip-margin'>
                            Payment Method
                          </Form.Label>
                          <div className='d-flex justify-content-between'>
                            <Form.Check
                              type='radio'
                              label='E-Mandate'
                              name='paymentMethod'
                              value={'payemandate'}
                              onChange={(e) => {
                                setNewSIP({
                                  ...newSIP,
                                  is_payment_manual: false,
                                  start_date: dateFromDateString(fivedaysAhead),
                                });
                                setSipMethod(e.target.value);
                                setStartDate(dateFromDateString(fivedaysAhead));
                              }}
                              checked={sipMethod == 'payemandate'}
                            />
                            <Form.Check
                              type='radio'
                              label='Pay Manually'
                              name='paymentMethod'
                              value={'paymanual'}
                              onChange={(e) => {
                                setNewSIP({
                                  ...newSIP,
                                  is_payment_manual: true,
                                  bank: '',
                                  start_date: dateFromDateString(todayDate),
                                });
                                setEmandates('withMandateUPI');
                                setSipMethod(e.target.value);
                                setStartDate(dateFromDateString(todayDate));
                              }}
                              checked={sipMethod == 'paymanual'}
                            />
                          </div>
                          {sipMethod == 'payemandate' && (
                            <div>
                              {/* <Form.Label className='sip-margin'>
                                E-Mandate
                              </Form.Label> */}

                              {emandateList?.length > 0 && (
                                <div>
                                  <Form.Label
                                    className='sip-margin'
                                    style={{ color: '#2575fc' }}
                                  >
                                    Use your existing mandate
                                  </Form.Label>
                                  <div className='d-flex align-items-center'>
                                    <Form.Check
                                      type='radio'
                                      // label='Use your existing mandate to avoid setting up another mandate'
                                      name='Emandates'
                                      value={'withoutMandate'}
                                      // value={"withoutMandate"}
                                      checked={emandates == 'withoutMandate'}
                                      onChange={(e) => {
                                        setEmandates(e.target.value);
                                      }}
                                    />

                                    <Form.Control
                                      as='select'
                                      className='m-1'
                                      value={newSIP?.bank ? newSIP?.bank : ''}
                                      onChange={(e) =>
                                        setNewSIP({
                                          ...newSIP,
                                          bank: e.target.value,
                                        })
                                      }
                                      disabled={
                                        emandates == 'withoutMandate'
                                          ? false
                                          : true
                                      }
                                    >
                                      <option value='' disabled>
                                        Select Bank / UPI
                                      </option>
                                      {emandateList?.map((e, index) => (
                                        <option value={e?.bank} key={index}>
                                          {e?.bank != null ? e?.bank : e?.vpa}
                                        </option>
                                      ))}
                                    </Form.Control>
                                    {/* )} */}
                                  </div>
                                </div>
                              )}
                              {/* <div>
                                <Form.Label
                                  className='sip-margin'
                                  style={{ color: '#2575fc' }}
                                >
                                  Create New E-Mandate
                                </Form.Label>

                                <Form.Check
                                  type='radio'
                                  label='E-Mandate (NetBanking/Debit card)'
                                  name='Emandates'
                                  value={'withMandate'}
                                  onChange={(e) => {
                                    setNewSIP({ ...newSIP, bank: '' });
                                    setEmandates(e.target.value);
                                  }}
                                  checked={emandates == 'withMandate'}
                                />
                              </div> */}
                              <div>
                                <Form.Label
                                  className='sip-margin'
                                  style={{ color: '#2575fc' }}
                                >
                                  Create New E-Mandate
                                </Form.Label>
                                <Form.Check
                                  type='radio'
                                  label='E-Mandate (UPI)'
                                  name='Emandates'
                                  value={'withMandateUPI'}
                                  onChange={(e) => {
                                    setNewSIP({
                                      ...newSIP,
                                      bank: '',
                                      isupi: true,
                                    });
                                    setEmandates(e.target.value);
                                  }}
                                  checked={emandates == 'withMandateUPI'}
                                />
                                <Form.Check
                                  type='radio'
                                  label='E-Mandate (NetBanking/Debit card)'
                                  name='Emandates'
                                  value={'withMandate'}
                                  onChange={(e) => {
                                    setNewSIP({ ...newSIP, bank: '' });
                                    setEmandates(e.target.value);
                                  }}
                                  checked={emandates == 'withMandate'}
                                />
                              </div>
                            </div>
                          )}
                          <Form.Label className='sip-margin'>
                            Start date
                          </Form.Label>

                          <Form.Control
                            type='date'
                            name='start_date'
                            value={dateForPicker(startDate)}
                            placeholder='dd/mm/yyyy'
                            onChange={(e) => {
                              setStartDate(dateFromDateString(e.target.value));
                              // setmanualStartDate(dateFromDateString(e.target.value));
                              setNewSIP({
                                ...newSIP,
                                start_date: dateFromDateString(e.target.value),
                              });
                            }}
                            min={dateForPicker(startDate)}
                          />
                          {/* <InputGroup className='sip-margin'>
                            <Form.Control
                              placeholder='Select below coupon'
                              aria-label="Recipient's username"
                              aria-describedby='basic-addon2'
                              // value={inputCouponName}
                              // onChange={(e) => handleChange(e)}
                              // disabled={true}
                            />

                            <button
                              className='btn btn-verify'
                              id='button-pan'
                              type='button'
                              // onClick={() => onApplyCoupon()}
                              // disabled={inputCouponName === '' ? true : false}
                            >
                              Apply coupon
                            </button>
                          </InputGroup> */}

                          <div className='container_checkbox '>
                            <Form.Check
                              className='sip-margin '
                              type='checkbox'
                              label={
                                <>
                                  By creating this SIP, you agree to the{' '}
                                  <a
                                    href='https://ebullion.in/terms-and-conditions/terms.html'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                      color: '#2575fc',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    Terms & Conditions
                                  </a>
                                </>
                              }
                              name='payment-group'
                              onClick={() => setIsConsented(!isConsented)}
                            ></Form.Check>
                          </div>
                        </Form.Group>

                        <Button
                          variant='primary'
                          className='btn-block mt-2'
                          type='submit'
                          size='lg'
                          disabled={!isConsented}
                        >
                          Create SIP
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </FormikForm>
          )}
        </Formik>
        {/* </div> */}
        <SipSummary
          key={'odrSmrpop'}
          handleModal={onHandleSideModal}
          isShow={dislaySipSummary}
          data={newSIP}
          displaySummary={true}
          emandates={emandates}
          sipMethod={sipMethod}
        />
      </div>
    </Layout>
  );
};

export default SipSavingPlan;
